import GatewayContainer from '../config/GatewayContainer';
import GatewayNames from '../constant/GatewayNames';
import { query } from '@trlogic/client-js';
import { CancelToken } from 'axios';
import { EntityData } from '../domain/stream/transaction/EntityDomains';
import EntityClient from '../client/integration/entity/EntityClient';

class EntityService {
  private entityClient: EntityClient = GatewayContainer.getInstance().get(GatewayNames.ENTITY_CLIENT);

  public getEntityData(
    channel: string | undefined,
    version: string,
    _query: query.SelectQuery,
    cancelToken?: CancelToken,
  ): Promise<{ data: EntityData[]; count: number }> {
    return this.entityClient.getEntityData(channel, version, _query, cancelToken);
  }

  public updateEntityNote(channel: string, version: string, id: string, users: string[]): Promise<void> {
    return this.entityClient.updateEntityNote(channel, version, id, users);
  }

  public commentEntity(domain: string, id: string, comment: string): Promise<void> {
    return this.entityClient.commentEntity(domain, id, comment);
  }

  public commentEditEntity(domain: string, comment: string, commentId: string): Promise<void> {
    return this.entityClient.commentEditEntity(domain, comment, commentId);
  }
}

export default EntityService;
